import { DeviceBrowserProvider } from './device.browser';
import { DeviceMobileProvider } from './device.mobile';
import { DeviceProvider } from './device';
import { Platform } from '@ionic/angular';

/**
 * Class constructor
 * @param platform 
 * @param composer 
 * @param permissions 
 * @param settings 
 */
export function deviceProviderFactory(platform: Platform): DeviceProvider
{
    // mobile apps are served on localhost:8080
    // filter by localhost to differentiate between
    // cordova in browser and cordova in app
    if (platform.is('hybrid'))
    {
        return new DeviceMobileProvider(platform);
    } else
    {
        return new DeviceBrowserProvider(platform);
    }
}
